import React from 'react';
import { Title } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import translate from 'Components/Helpers/translate';
import './FileUploadDropzoneActive.scss';

interface FileUploadDropzoneActiveProps {
	visible: boolean;
}

const FileUploadDropzoneActive = ({ visible }: FileUploadDropzoneActiveProps) => {
	const classes = new bemClass('FileUploadDropzoneActive');
	return (
		<div className={classes.mod({ visible }).b()}>
			{/* class used for modal styling */}
			<div className={classes.elem('instructions').b()}>
				<svg
					width="80"
					height="110"
					viewBox="0 0 120 151"
					className="file-drop-icon"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
				>
					<g className="card" fill="none" fillRule="evenodd">
						<path
							className="paper"
							fill="#E4EDF7"
							d="M13,3.00972645 C13,1.34750043 14.3424077,0 16.0020839,0 L85,0 L107,22 L107,113.999935 C107,115.656825 105.653127,117 104.005268,117 L15.9947322,117 C14.3407873,117 13,115.665878 13,113.990274 L13,3.00972645 Z"
						/>
						<path
							className="arrow"
							fill="#4A90E2"
							d="M73.0412946,61.2142857 C73.0412946,61.8058065 72.8348235,62.3080336 72.421875,62.7209821 L61.5234375,73.6361607 C61.0881675,74.0491092 60.58036,74.2555804 60,74.2555804 C59.4084792,74.2555804 58.9062521,74.0491092 58.4933036,73.6361607 L47.5948661,62.7209821 C47.1707568,62.3191944 46.9587054,61.8169673 46.9587054,61.2142857 C46.9587054,60.6227649 47.1707568,60.1149575 47.5948661,59.6908482 L48.8337054,58.4352679 C49.2689754,58.0223194 49.7767828,57.8158482 50.3571429,57.8158482 C50.9486637,57.8158482 51.4508908,58.0223194 51.8638393,58.4352679 L56.7857143,63.3571429 L56.7857143,51.5714286 C56.7857143,50.9910685 56.9977657,50.4888414 57.421875,50.0647321 C57.8459843,49.6406229 58.3482114,49.4285714 58.9285714,49.4285714 L61.0714286,49.4285714 C61.6517886,49.4285714 62.1540157,49.6406229 62.578125,50.0647321 C63.0022343,50.4888414 63.2142857,50.9910685 63.2142857,51.5714286 L63.2142857,63.3571429 L68.1361607,58.4352679 C68.5491092,58.0223194 69.0513363,57.8158482 69.6428571,57.8158482 C70.2232172,57.8158482 70.7310246,58.0223194 71.1662946,58.4352679 L72.421875,59.6908482 C72.8348235,60.1261182 73.0412946,60.6339257 73.0412946,61.2142857 Z"
						/>
						<path
							className="fold"
							fill="#4A90E2"
							opacity=".2"
							d="M84,0.0459127487 C84,-0.511600348 84.3143399,-0.649214134 84.7031002,-0.260453851 L106.789944,21.8263904 C107.178256,22.2147019 107.044718,22.5294906 106.483578,22.5294906 L85.0094668,22.5294906 C84.4519537,22.5294906 84,22.0811639 84,21.5200238 L84,0.0459127487 Z"
						/>
					</g>
					<ellipse
						className="shadow"
						id="shadow"
						cx="60"
						cy="147"
						fill="#000000"
						opacity=".1"
						rx="60"
						ry="4"
					/>
				</svg>
				<Title>{translate('file.dropYourFileHere')}</Title>
			</div>
		</div>
	);
};

export default FileUploadDropzoneActive;
